<ng-container *ngIf="dataItem">
	<!-- Вводим мастхед -->
	<div *ngIf="dataItem.type=='masthead'"
		 class="plate plate--masthead"
		 [class.default]="noUrlItem"
		 [ngClass]="classList">
		<ng-container *ngIf="dataItem.video_id && dataItem.video_type">
			<img *ngIf="dataItem.videos[0].image_path"
				 [src]="baseUrl +dataItem.videos[0].image_path"
				 alt="{{dataItem.name}}"
				title="{{dataItem.name}}">
			<div *ngIf="visibleVideo"
				 class="icon icon--play main-work__play"
				 (click)="playVideo(dataItem.video_id,dataItem.video_type)"></div>
		</ng-container>
		<ng-container *ngIf="!dataItem.video_id || !dataItem.video_type">
			<img *ngIf="dataItem.mainImage"
				 [src]="baseUrl + dataItem.mainImage"
				 alt="{{dataItem.name}}"
				 title="{{dataItem.name}}">
		</ng-container>
		<!--If link-->
		<a *ngIf="!noUrlItem" [routerLink]="srcUrl? [srcUrl,dataItem.id] : dataItem.id" class="plate__content">
			<i *ngIf="dataItem.brands && dataItem.brands.length">
				<ng-container *ngFor="let brand of dataItem.brands;index as i">
					{{brand.brand_name}}<ng-container *ngIf="i+1 != dataItem.brands.length">,</ng-container>
				</ng-container>
			</i>
			<p>{{dataItem.name}}</p>
		</a>
	</div>

	<!-- Вводим людей -->
	<div *ngIf="dataItem.type=='people'"
		 class="plate plate-js plate--work animation-show plate--block{{imageType}}"
		 [ngClass]="classList">
		<div class="plate__bg"
			 *ngIf="imageType && dataItem['image_path_' + imageType]"
			 [style.background-image]="getBackgroundImage(dataItem['image_path_' + imageType])"></div>
		<a class="plate__content" [routerLink]="srcUrl ? [srcUrl,dataItem.id] : dataItem.id">
			<i *ngIf="dataItem.position">{{dataItem.position}}</i>
			<p *ngIf="dataItem.name">{{dataItem.name}}</p>
		</a>
	</div>

	<!-- Вводим работы -->
	<div *ngIf="dataItem.type=='work'"
		 class="plate plate-js plate--work animation-show plate--{{imageType}}"
		 [ngClass]="classList">
		<div class="plate__bg"
			 *ngIf="imageType && dataItem.tiles && dataItem.tiles[imageType] && dataItem.tiles[imageType][0]"
			 [style.background-image]="getBackgroundImage(dataItem.tiles[imageType][0])"></div>
		<a class="plate__content" [routerLink]="srcUrl? [srcUrl,dataItem.id] : dataItem.id">
			<i *ngIf="dataItem.brands && dataItem.brands.length">
				<ng-container *ngFor="let brand of dataItem.brands;index as i">
					{{brand.brand_name}}<ng-container *ngIf="i+1 != dataItem.brands.length">,</ng-container>
				</ng-container>
			</i>
			<p>{{dataItem.name}}</p>
		</a>
	</div>

	<!-- Вводим ссылку -->
	<div *ngIf="dataItem.type=='link'"
		 class="plate plate-js animation-show  plate--{{imageType}}"
		 [ngClass]="classList"
		 [class.plate--dark]="dataItem.bg_color=='dark'" [class.plate--light]="dataItem.bg_color=='light'"
		 [class.plate--no-lead]="dataItem.bg_color=='dark' && (!dataItem.lead || dataItem.lead.length==0)">
			<div class="plate__bg"
				 *ngIf="dataItem.bg_color=='dark'"
				 [style.background-image]="getBackgroundImage(dataItem[imageType])"></div>
			<a class="plate__content" href="{{dataItem.link}}" target="_blank">
				<i *ngIf="dataItem.title">{{dataItem.title}}</i><br>
				<p *ngIf="dataItem.lead">{{dataItem.lead}}</p>
			</a>
	</div>
</ng-container>
